
export enum AppRoutes {
    MAIN = 'main',
    BOOK = 'book'
}

export enum ChildAppRoutes {
    MAIN_PAGE = 'MAIN_PAGE',

}

export const getRouteMainPage = () => '/main'



